import React, { useState, useRef, } from 'react';
import { Card } from 'primereact/card';
import './social.scss';

import LinkedinImg from './linkedin.png'
import GithubImg from './github.png'
import GmailImg from './gmail.png'
const copyMaild = () => {
  console.log('copied');
}

function Social(props) {
  console.log(props);
  return (
    <div className="tech">
      <div className="title">Where to find me </div>
      <div className="p-grid p-justify-around card-grid-wrapper">
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card" target="_blank">
            <a href="https://www.linkedin.com/in/viraj-gawde/">
              <img src={LinkedinImg} className="card-img" />
              <div className="card-overlay">/in/viraj-gawde/</div>
            </a>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <a href="https://github.com/virajrg108/">
              <img src={GithubImg} className="card-img" />
              <div className="card-overlay">/virajrg108</div>
            </a>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card" >
            <img onClick={()=>props.copyMail()} src={GmailImg} className="card-img" />
            <div onClick={()=>props.copyMail()} className="card-overlay">viraj.gawde123@gmail.com</div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Social;